/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Date_InvalidInputs */

const vi_error_shop_date_invalid = /** @type {(inputs: Error_Shop_Date_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày chưa hợp lệ, chọn lại ngày trên lịch.`)
};

/**

* @param {Error_Shop_Date_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_date_invalid = /** @type {((inputs?: Error_Shop_Date_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Date_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_date_invalid(inputs)
});